module.exports = "<span>\n  {{snackBarData}}\n</span>\n"